export const isWholeNumber = num => typeof num === 'number' && isFinite(num) && Math.floor(num) === num;